import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col sm:flex-row items-center sm:items-start gap-5 rounded-2xl border border-gray-100 bg-white shadow-sm p-6" }
const _hoisted_2 = ["cx", "cy", "stroke"]
const _hoisted_3 = ["cx", "cy", "stroke", "stroke-dashoffset"]
const _hoisted_4 = { class: "text-2xl font-bold" }
const _hoisted_5 = { class: "flex flex-col items-center sm:items-start gap-2" }
const _hoisted_6 = { class: "text-2xl font-bold text-gray-900 text-center sm:text-left" }
const _hoisted_7 = { class: "flex flex-wrap items-center justify-center sm:justify-start gap-2" }
const _hoisted_8 = { class: "flex items-center gap-1 text-sm text-gray-500" }

import { computed } from 'vue'
import { mdiOfficeBuildingOutline } from '@mdi/js'

import LabelBadge from '@/components/designSystem/Badges/LabelBadge.vue'
import ProtectedAvatar from '@/components/designSystem/AvatarUser/ProtectedAvatar.vue'
import type { DoctorDetailResponse } from '@/Network/Types/Responses/CompanyResponses'
import { classifyNpsScore, NEUTRAL_RING_COLOR } from '@/utils/nps'
import {
  getCrmStatusConfig,
  getInitials,
  resolveAvatarUrl,
  toTitleCase
} from '../../helpers/doctorStatus'

const AVATAR_SIZE = 80
const STROKE_WIDTH = 4

export default /*#__PURE__*/_defineComponent({
  __name: 'DoctorHeader',
  props: {
    doctor: {}
  },
  setup(__props: any) {

const props = __props;



const doctorName = computed(() =>
  toTitleCase(props.doctor.doctor.user?.name || props.doctor.doctor.mainCrm.name)
)

const avatarSrc = computed(() => resolveAvatarUrl(props.doctor.doctor.user?.avatarUrl))

const initials = computed(() => getInitials(doctorName.value))

const radius = AVATAR_SIZE / 2 + STROKE_WIDTH / 2
const svgSize = radius * 2 + STROKE_WIDTH
const circumference = 2 * Math.PI * radius

const clampedScore = computed(() => {
  const score = props.doctor.doctor.npsScore
  if (score == null) return 0
  return Math.min(100, Math.max(0, (score + 100) / 2))
})

const offset = computed(() => circumference * (1 - clampedScore.value / 100))

const arcColor = computed(() => {
  const score = props.doctor.doctor.npsScore
  if (score == null) return NEUTRAL_RING_COLOR
  return classifyNpsScore(score).color
})

const crmStatus = computed(() => getCrmStatusConfig(props.doctor.doctor.mainCrm.status))

const companiesLabel = computed(() => {
  const count = props.doctor.companies.length
  return count === 1 ? '1 empresa vinculada' : `${count} empresas vinculadas`
})

return (_ctx: any,_cache: any) => {
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "relative shrink-0",
      style: _normalizeStyle({ width: svgSize + 'px', height: svgSize + 'px' })
    }, [
      (_openBlock(), _createElementBlock("svg", {
        width: svgSize,
        height: svgSize,
        class: "absolute top-0 left-0 -rotate-90",
        "aria-hidden": "true"
      }, [
        _createElementVNode("circle", {
          cx: svgSize / 2,
          cy: svgSize / 2,
          r: radius,
          stroke: _unref(NEUTRAL_RING_COLOR),
          "stroke-width": STROKE_WIDTH,
          fill: "none"
        }, null, 8, _hoisted_2),
        (clampedScore.value > 0)
          ? (_openBlock(), _createElementBlock("circle", {
              key: 0,
              cx: svgSize / 2,
              cy: svgSize / 2,
              r: radius,
              stroke: arcColor.value,
              "stroke-width": STROKE_WIDTH,
              fill: "none",
              "stroke-dasharray": circumference,
              "stroke-dashoffset": offset.value,
              "stroke-linecap": "round"
            }, null, 8, _hoisted_3))
          : _createCommentVNode("", true)
      ])),
      _createVNode(_component_v_avatar, {
        color: "primary",
        size: AVATAR_SIZE,
        class: "absolute",
        style: _normalizeStyle({ top: STROKE_WIDTH + 'px', left: STROKE_WIDTH + 'px' })
      }, {
        default: _withCtx(() => [
          _createVNode(ProtectedAvatar, {
            src: avatarSrc.value,
            size: AVATAR_SIZE
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_4, _toDisplayString(initials.value), 1)
            ]),
            _: 1
          }, 8, ["src"])
        ]),
        _: 1
      }, 8, ["style"])
    ], 4),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("h1", _hoisted_6, _toDisplayString(doctorName.value), 1),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(LabelBadge, {
          label: `CRM ${_ctx.doctor.doctor.mainCrm.number}-${_ctx.doctor.doctor.mainCrm.uf}`,
          color: "blue",
          icon: null,
          size: "small"
        }, null, 8, ["label"]),
        (crmStatus.value)
          ? (_openBlock(), _createBlock(LabelBadge, {
              key: 0,
              label: crmStatus.value.label,
              color: crmStatus.value.color,
              icon: null,
              size: "small"
            }, null, 8, ["label", "color"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_v_icon, { size: "16" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(mdiOfficeBuildingOutline)), 1)
          ]),
          _: 1
        }),
        _createElementVNode("span", null, _toDisplayString(companiesLabel.value), 1)
      ])
    ])
  ]))
}
}

})